<app-modal-template
  class="spinner-modal"
  [class.no-title]="!title"
  [size]="pencilModalSizeEnum.SMALL"
  [title]="title"
>
  <div class="modal-content-container" content-description>
    <app-loading-v2 [showMessage]="false"></app-loading-v2>
    <div>
      <div *ngIf="description" [innerHtml]="description"></div>
    </div>
  </div>
</app-modal-template>
